import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/projects',
    name: 'projects',
    component: () => import('../views/projects.vue'),
  },
  {
    path: '/games',
    name: 'Games',
    component: () => import('../views/games.vue'),
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to,from,savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

router.beforeEach((to, from, next) => {
  // to and from are both route objects. must call `next`.
  var title = to.name.charAt(0).toUpperCase() + to.name.slice(1) + " | WuttiFrutti "

  document.title = title
  next();
})

export default router
